<template>
  <div id="recovegift" class="relativeItem" @click="closeGiftBox">
    <div class="giftBox absoluteItem" @click.stop>
      <img src="../../assets/live/bg.png" class="imgBlock" />
      <div class="absoluteItem shell">
        <!-- 右上的小图标 -->
        <img class="closeIcon" src="../../assets/live/close.png" @click="closeGiftBox" />
        <!-- 礼物的父盒子 -->
        <div class="ulBox" :style="{ height: ulboxheight + 'px'}">
          <!-- 每一个礼物的小盒子 -->
          <div class="smallBox" v-for="(item,index) in giftIconList" :key="index">
            <div
              class="boxIcon"
              @click="selectGift(item,item.giftid)"
              :style="{ width: width + 'px', height: width + 'px'}"
            >
              <img :src="item.giftimage" class="img" />
              <img src="../../assets/live/selectBox.png" class="selectBg" v-show="item.isActive" />
            </div>
            <p class="boxdec apostrophe" :style="{width: width + 'px'}">
              {{item.giftname}}
              <i>×{{item.num}}</i>
            </p>
            <p class="danprice">{{item.num*item.recovery_price}} {{giftunit}}</p>
          </div>
        </div>
      </div>

      <!-- 回收礼物获得珍珠 全选的-->
      <div class="selectBox">
        <p v-if="showBtn">
          已选
          <i>{{selectgiftnums}}</i>件
        </p>
        <p v-else>回收礼物获得钻石</p>
        <div class="leftselect" @click="allClickSelected">
          <img src="@/assets/live/sellect.png" alt v-if="allSelect" />
          <img src="@/assets/live/unselect.png" alt v-else />
          <p>全选</p>
        </div>
      </div>

      <!-- 底部回收的盒子 -->
      <div class="bottomBoxbtn">
        <div>{{totalPrice}}</div>
        <!-- 回收按钮 -->
        <div @click="handleBtn">
          <!-- 选中 -->
          <img
            src="@/assets/live/huishoubg.png"
            v-if="showBtn"
            :class="{'hsBtnActive': isSelected}"
          />
          <!-- 未选中 -->
          <img src="@/assets/live/huishou.png" v-else />
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <div class="tc" v-show="showConfirmBox" @click.stop>
      <div class="confirmBox">
        <!-- 顶部盒子 -->
        <div class="topBox">
          <div>回收可得</div>
          <div>
            <img src="../../assets/live/xiubi.png" alt />
          </div>
          <div>×{{totalPrice}}</div>
        </div>
        <!-- 中间盒子 -->
        <div class="middleBox">(礼物将被回收，请谨慎操作)</div>
        <!-- 底部按钮 -->
        <div class="bottomBox">
          <!-- 取消 -->
          <img src="../../assets/live/canle.png" alt @click="canleTouch" />
          <!-- 确认 -->
          <img src="../../assets/live/hsconfirm.png" alt @click="confirmTouch" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "recovegift",
  components: {},
  data() {
    return {
      // 礼物的小图标
      giftIconList: [
        // { giftid: 1, giftname: "棒棒糖", giftimage: "", isActive: false , num:"2",recovery_price: "20"},
        // { giftid: 2, giftname: "棒棒糖1232", giftimage: "", isActive: false , num:"2",recovery_price: "20"},
      ],
      // 选中的礼物个数
      selectNum: 0,
      // 选中的礼物数量总数
      selectgiftnums: 0,
      //显示回收的颜色
      showBtn: false,
      // 按钮的全选
      allSelect: false,
      // 弹框的显示隐藏
      showConfirmBox: false,
      // 动态计算的宽度
      width: 0,
      // 礼物盒子的高度
      ulboxheight: 0,
      // 回收按钮选中的放大效果
      isSelected: false,
      // 选中的总价格
      totalPrice: 0,
      // 选中的礼物项数组
      newList: [],
      // 选中的礼物ID数组
      giftIds: [],
      // 后缀单位
      giftunit: ""
    };
  },
  created() {
    let _this = this;
    this.$jsonp(_this.$apis("giftstore"), {}, res => {
      _this.giftIconList = res.data.data.data.list;
    });
  },
  mounted() {
    // 动态设置礼物盒子的宽高
    this.width = this.$tool.calculateWidthHeight('.ulBox',  0.1875);
    this.ulboxheight = this.$tool.calculateWidthHeight('.ulBox',  0.58);
    this.getUnit();
  },
  methods: {
    // 获取单位
    getUnit() {
      let _this = this;
      this.$jsonp(
        _this.$apis("live_gift_unit"),
        {},
        res => {
         _this.giftunit = res.body.data.result.list.money_name
        }
      );
    },
    // 全选点击
    allClickSelected() {
      if (this.giftIconList.length == 0) {
        // 没有礼物就禁止
        this.showBtn = false;
        // 没有礼物就提示  无礼物可回收
        this.$tool.tip("暂无可回收礼物", "50%");
      } else {
        this.allSelect = !this.allSelect;
        this.newList = [];
        if (this.allSelect) {
          // 全选选中
          this.giftIconList.forEach(item => {
            item.isActive = true;
            this.newList.push(item);
          });
          this.showBtn = true;
          this.totalPrice = 0;
          this.selectNum = this.giftIconList.length;
          // 全选中的总个数
          this.selectgiftnums = 0;
          for (let i = 0; i < this.giftIconList.length; i++) {
            this.selectgiftnums += this.giftIconList[i].num - 0;
          }
          this.allTotalPrice(this.newList);
        } else {
          // 未全选
          this.giftIconList.forEach(item => {
            item.isActive = false;
          });
          this.showBtn = false;
          this.selectNum = 0;
          this.selectgiftnums = 0;
          this.totalPrice = 0;
        }
      }
    },
    closeGiftBox() {
      this.$appAc.closeWeb();
    },
    // 每一个礼物项被点击
    selectGift(cgift, id) {
      cgift.isActive = !cgift.isActive;
      if (cgift.isActive) {
        this.totalPrice = 0;
        // 选中的
        this.selectNum++;
        this.showBtn = true;
        this.selectNum == this.giftIconList.length
          ? (this.allSelect = true)
          : (this.allSelect = false);
        // 选中的新数组
        this.newList = this.giftIconList.filter(item => {
          return item.isActive == true;
        });
        this.allTotalPrice(this.newList);
        this.getAllGiftNums(); //调用总的个数计算方法
      } else {
        // 取消选中
        this.selectNum--;
        this.selectNum < this.giftIconList.length
          ? (this.allSelect = false)
          : (this.allSelect = true);
        this.selectNum == 0 ? (this.showBtn = false) : (this.showBtn = true);

        for (let i = 0; i < this.newList.length; i++) {
          this.newList[i].giftid == id;
          if (this.newList[i].giftid == id) {
            this.newList.splice(i, 1);
          }
        }
        this.getAllGiftNums(); //调用总的个数计算方法
        this.totalPrice = 0;
        this.allTotalPrice(this.newList);
      }
    },
    // 计算总的礼物个数 num的累加
    getAllGiftNums() {
      this.selectgiftnums = 0;
      for (let i = 0; i < this.newList.length; i++) {
        this.selectgiftnums += this.newList[i].num - 0;
      }
    },
    // 计算allTotalPrice
    allTotalPrice(arr) {
      for (let gi = 0; gi < arr.length; gi++) {
        let totalP = (arr[gi].recovery_price - 0) * (arr[gi].num - 0);
        this.totalPrice += totalP;
      }
    },
    // 点击回收按钮显示弹框
    handleBtn() {
      if (this.giftIconList.length == 0) {
        this.showBtn = false;
        // 没有礼物就提示  无礼物可回收
        this.$tool.tip("暂无可回收礼物", "50%");
      }
      if (this.giftIconList.length != 0 && this.selectNum == 0) {
        this.$tool.tip("请选择要回收的礼物", "50%");
      }

      this.isSelected = !this.isSelected;
      // 回收带背景被选中
      if (this.showBtn) {
        this.showConfirmBox = true;
      }
    },
    // 弹窗点击取消
    canleTouch() {
      this.showConfirmBox = false;
    },
    // 弹窗点击确认
    confirmTouch() {
      // 获取选中礼物的ID数组
      this.giftIdsarr = this.newList.filter(item => {
        return item.isActive == true;
      });
      this.giftIds = [];
      for (let i = 0; i < this.giftIdsarr.length; i++) {
        this.giftIds.push(this.giftIdsarr[i].giftid);
      }
      let _this = this; //礼物回收成功
      this.$jsonp(
        _this.$apis("giftrecovery"),
        { giftid: _this.giftIds },
        res => {
          if (res.body.data.status === 200) {
            this.$tool.tip(res.body.data.data.msg, "50%");
            setTimeout(() => {
              this.$appAc.closeWeb();
              this.$appAc.toRefreshGift();
            }, 1000);
          } else {
            this.$tool.tip("礼物回收失败", "50%");
            this.showConfirmBox = true;
          }
        }
      );
      this.showConfirmBox = false;
    }
  }
};
</script>

<style scoped>
#recovegift {
  height: 100vh;
  background: none;
}
.recover {
  height: 100%;
}
.giftBox {
  width: 100%;
  bottom: 10%;
  background: none;
  border-bottom-left-radius: 8%;
  border-bottom-right-radius: 8%;
  box-shadow: 0 2px 6px rgba(0,0,0,.16)
}
.shell {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.giftBoxmain {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.giftBox > img {
  width: 100%;
}
.shell .closeIcon {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 5px;
  top: 18%;
}

.ulBox {
  position: absolute;
  bottom: 90px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 210px;
  border-radius: 4%;
  padding: 10px 5%;
  background: linear-gradient(to bottom, #7132d6, #6278e0);
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  flex-flow: wrap;
  justify-content: flex-start;
}
.ulBox i {
  font-style: normal;
}
.smallBox {
  margin: 5px 0;
  margin-right: 5%;
  text-align: center;
}
.smallBox:nth-child(4n) {
  margin-right: 0;
}
.smallBox .boxIcon {
  background: url("../../assets/live/giftbox.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 10%;
  overflow: hidden;
  position: relative;
  padding: 4px;
}
/* 礼物项被点击  */
.selectBg {
  position: absolute;
  top: 0;
  left: 0;
}
/* .boxIcon .selectBg {
  width: 100%;
  height: 100%;
} */
.boxIcon img {
  width: 100%;
  height: 100%;
}
.smallBox .boxdec {
  margin-top: 2px;
  color: #4908a6;
  font-size: 12px;
}
.smallBox .danprice {
  font-size: 12px;
  color: #ffd856;
}
.selectBox {
  width: 100%;
  position: absolute;
  bottom: 66px;
  display: flex;
  justify-content: space-between;
}
.selectBox i {
  margin: 0 5px;
  font-style: normal;
  color: #fff;
}
.selectBox img {
  width: 20px;
  height: 20px;
}
.selectBox > p {
  font-size: 14px;
  color: #4d58d7;
  margin-left: 40px;
}
/* 右侧的选择盒子 */
.selectBox .leftselect {
  display: flex;
  justify-content: space-around;
  margin-right: 50px;
}
.leftselect p {
  color: #fff;
  margin-left: 10px;
  font-size: 14px;
}
.bottomBoxbtn {
  position: absolute;
  bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
}
.bottomBoxbtn div:first-child {
  width: 130px;
  background: url("../../assets/live/xiubibg.png") no-repeat;
  background-size: contain;
  color: #ffd856;
  line-height: 30px;
  margin-top: 15px;
  text-align: center;
}
.bottomBoxbtn img {
  background-size: 100px 40px;
  width: 100px;
  height: 40px;
  margin-top: 10px;
}
/* 弹窗确认的样式 */
.tc {
  position: relative;
}
.tc .confirmBox {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 130px;
  width: 80%;
  height: 170px;
  background: url("../../assets/live/tanchuang.png") no-repeat;
  background-size: contain;
}
.confirmBox .topBox {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 40px;
  width: 56%;
  height: 50px;
  line-height: 33px;
  display: flex;
  justify-content: space-around;
  color: #fff;
}
.topBox div:last-child {
  color: #ffd856;
}
.topBox img {
  width: 30px;
  height: 30px;
}
.confirmBox .middleBox {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 75px;
  color: #a697f3;
  font-size: 12px;
  width: 64%;
  text-align: center;
}
.confirmBox .bottomBox {
  display: flex;
  justify-content: space-between;
  position: absolute;
  left: 50%;
  width: 66%;
  transform: translateX(-50%);
  top: 105px;
}
.confirmBox .bottomBox img {
  width: 86px;
  height: 38px;
}
.tcbox {
  height: 100%;
}
.hsBtnActive {
  transform: scale(1.05);
  transition: all ease 0.5;
}
</style>